module.exports = __webpack_public_path__ + "static/media/chevron-white.c3e8c5cc.svg";